import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgoDetailed'
})
export class TimeAgoDetailedPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    const now = new Date();
    const date = new Date(value);
    let diff = Math.floor((now.getTime() - date.getTime()) / 1000); // in seconds

    if (diff <= 0) return 'just now';

    const units: [string, number][] = [
      ['year', 365 * 24 * 60 * 60],
      ['month', 30 * 24 * 60 * 60],
      ['day', 24 * 60 * 60],
      ['hour', 60 * 60],
      ['minute', 60],
      ['second', 1]
    ];

    const result: string[] = [];

    for (const [name, seconds] of units) {
      const value = Math.floor(diff / seconds);
      if (value > 0) {
        result.push(`${value} ${name}${value > 1 ? 's' : ''}`);
        diff %= seconds;
      }
    }

    return result.length ? result.join(' ') + ' ago' : 'just now';
  }
}
